import {
  CreateTurnRequestService,
  CreateTurnResponseService,
  EditTurnRequestService,
  EditTurnResponseService,
  GetAllAppointmentCandidates,
  GetAllAppointmentEmployee,
  GetAllAppointmentPatient,
  GetAllAppointmentsResponseService,
  GetAppointmentEditResponseService,
  IndividualAppointmentResponseService,
  PracticesResponseService,
  AvailabilitySlotsOption,
  RequestTurnBody,
  PracticesResponseServicewithPagination,
  GetOneAppointmentResponseService,
  RequesPrestadortTurnBody,
  PracticesResponseServiceItem,
  IndividualAppointment,
  RequestMultipleTurnBody,
  CreateTurnMultipleResponseService
} from "./Turns.type";
import { useDispatch, useStore } from "react-redux";

import { AxiosInstance } from "axios";
import { UpdateByOptions, UpdateToRequest } from "../../pages/others/editTurn/types";

export default class TurnServices {
  private axios: AxiosInstance;
  public dispatch = useDispatch();
  public getStore = useStore();
  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  //GET ALL TURN SLOTS AVAILABLE
  public async getTurnSlots({
    molde,
    exam,
    practices,
  }: {
    molde?: string;
    exam?: string;
    practices?: string;
  }): Promise<AvailabilitySlotsOption> {
    // TODO: CREATE RETURN TYPE OF THIS REQUEST
    const practicesUrl = practices ? `practices=${practices}` : "";
    const examUrl = exam ? `&exam=${exam}` : "";
    const moldeUrl = molde ? `&molde=${molde}` : "";

    const url: string = `appointments/options?${practicesUrl}${moldeUrl}${examUrl}`;

    return this.axios.get(url);
  }


  // GET ALL AVAILABLE PRACTICES WITH PAGINATION
  public async getAllPractices(
    page?: number,
    itemsPerPage?: number,
  ): Promise<PracticesResponseServicewithPagination> {
    const url: string = `/practices?page=${page}&items=${itemsPerPage}`;
    return this.axios.get(url);
  }


  // GET ALL AVAILABLE PRACTICES WITH NO LOCATION
  public async getAllPracticesWithNoLocation(type: any[]): Promise<PracticesResponseServiceItem[]> {
    const url: string = `/practices/noLocationPc`;
    return this.axios.get(url, {
      params: {
        type
      }
    });
  }

  public async getAbsenteeInLavorisPractices(): Promise<PracticesResponseServiceItem[]> {
    const url: string = `/practices/absentee_in_lavoris`;
    return this.axios.get(url);
  }

  // GET ALL AVAILABLE PRACTICES
  public async getAllPracticesData(): Promise<PracticesResponseService> {
    const url: string = `/practices/data`;
    return this.axios.get(url, {
      method: "get",
    });
  }



  // CREATE A NEW TURN
  public async CreateTurnService(
    req: CreateTurnRequestService,
  ): Promise<CreateTurnResponseService> {
    const url: string = "/appointments";
    return this.axios.post(url, req);
  }

  // REQUEST A NEW TURN
  public async RequestTurnService(
    req: RequestTurnBody,
  ): Promise<CreateTurnResponseService> {
    const url: string = "/appointments/request";
    return this.axios.post(url, req);
  }
  // REQUEST A NEW CONSULTORIO ABSENTEE TURN
  public async RequestAbsenteeTurnService(
    req: RequestTurnBody,
  ): Promise<CreateTurnResponseService> {
    const url: string = "/appointments/absentee/request";
    return this.axios.post(url, req);
  }

  // REQUEST A NEW TURN
  public async RequestMultipleTurnService(
    req: RequestMultipleTurnBody,
  ): Promise<CreateTurnMultipleResponseService> {
    const url: string = "/appointments-pc/multiplerequests";
    return this.axios.post(url, req);
  }

  //REQUEST PARTICULAR CLIENT NEW TURN
  public async RequestParticularCLientTurnService(
    req: RequestTurnBody,
  ): Promise<CreateTurnResponseService> {
    const url: string = "/appointments-particular/request";
    return this.axios.post(url, req);
  }

  // REQUEST PRESTADOR A NEW TURN
  public async RequestPrestadorTurnService(
    req: RequesPrestadortTurnBody,
  ): Promise<CreateTurnResponseService> {
    const url: string = "/appointments/prestadores/requestPC";
    return this.axios.post(url, req);
  }

  // DELETE A SPECIFIC TURN
  public async DeleteTurn(id: string) {
    const url: string = `/appointments/cancel/${id}`;
    return this.axios.get(url);
  }

  // MODIFY AN EXISTING TURN
  public async EditTurnService(
    req: EditTurnRequestService | UpdateByOptions,
    appointmentId: string,
  ): Promise<EditTurnResponseService> {
    const url: string = `/appointments/${appointmentId}`;
    return this.axios.patch(url, req);
  }

  public async UpdateToRequest(
    req: UpdateToRequest,
    appointmentId: string,
  ): Promise<EditTurnResponseService> {
    const url: string = `/appointments/${appointmentId}/request`;
    return this.axios.patch(url, req);
  }
  public async UpdatePrestadorAppRequest(
    req: any,
    appointmentId: string,
  ): Promise<EditTurnResponseService> {
    const url: string = `/appointments/prestadores/requestedPC/${appointmentId}`;
    return this.axios.patch(url, req);
  }

  public async updateCertificate(
    req: { certificate: File },
    id: string
  ): Promise<void> {
    const url: string = `/appointments/${id}/upload`;
    const formData = new FormData();
    formData.append("file", req.certificate);
    formData.append("fileName", req.certificate.name);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return this.axios.patch(url, formData, config);
  }

  // Add Absence Certificate
  public async AddCertificate(
    req: { certificate: File },
    id: string,
  ): Promise<void> {
    const url: string = `/appointments/${id}/upload`;
    const formData = new FormData();
    formData.append("file", req.certificate);
    formData.append("fileName", req.certificate.name);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return this.axios.post(url, formData, config);
  }


  ///SERVICIO PARA LOS ARCHIVOS ADJUNTOS AL MOMENTO DE CARGAR/EDITAR UN TURNO (LISTADO/SOLICITADOS)
  public async addFile(
    req: { file: File },
    id: string,
  ): Promise<void> {
    const url: string = `/appointments/${id}/appFile`;
    const formData = new FormData();
    formData.append("file", req.file);
    formData.append("fileName", req.file.name);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return this.axios.post(url, formData, config);
  }



  public async updateFile(
    req: { file: File },
    id: string,
  ): Promise<void> {
    const url: string = `/appointments/${id}/appFile`;
    const formData = new FormData();
    formData.append("file", req.file);
    formData.append("fileName", req.file.name);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return this.axios.patch(url, formData, config);
  }

  public async deleteTurnFile(id: any) {
    const url: string = `/appointments/${id}/appFile`;
    return this.axios.delete(url);
  }

  /** Elimina un archivo adjunto por su id (si el backend lo soporta). Si no, usar deleteTurnFile(appointmentId). */
  public async deleteTurnFileByFileId(appointmentId: string, fileId: string) {
    const url: string = `/appointments/${appointmentId}/appFile/${fileId}`;
    return this.axios.delete(url);
  }



  /******************************************************************************************* */
  public async getAppointmentsRequestedByCompanyId(
    companyId: string,
    itemsPerPage: number,
    page: number,
    from: string,
    to: string,
    signal?: AbortSignal,
    search?: string | null,
    status?: string[],
    isCandidateOnly?: boolean
  ): Promise<IndividualAppointment[]> {
    const url: string = `/appointments-pc/requested?companyId=${companyId}&page=${page}&items=${itemsPerPage}&from=${from}&to=${to}&search=${search}&status=${status}&isCandidateOnly=${isCandidateOnly}`;
    return this.axios.get(url, {
      method: "get",
      signal
    });
  }

  public async getAppointmentsByDNI(dni: string, signal?: AbortSignal): Promise<any[]> {
    const url: string = `appointments-pc/dniSearch/${dni}`;
    return this.axios.get(url, { method: "get", signal });
  }


  public async getAppointmentsWithSearchQueryByCompaniesId(
    companyId: string,
    itemsPerPage: number,
    page: number,
    from: string,
    to: string,
    signal?: AbortSignal,
    search?: string | null,
    status?: string[],
    isCandidateOnly?: boolean
  ): Promise<{ items: any[] }> {
    search = !search ? "" : search;
    const url: string = `/appointments-pc/querySearch?companyId=${companyId}&page=${page}&items=${itemsPerPage}&from=${from}&to=${to}&search=${search}&status=${status}&isCandidateOnly=${isCandidateOnly}`;
    return this.axios.get(url, {
      method: "get",
      signal
    });
  }
  public async getAppointmentsWithSearchQueryByCompaniesIdInLavoris(
    companyId: string,
    itemsPerPage: number,
    page: number,
    from: string,
    to: string,
    signal?: AbortSignal,
    search?: string | null,
    status?: string[]
  ): Promise<any[]> {
    search = !search ? "" : search;
    const url: string = `/appointments-pc/requested/inlavoris?companyId=${companyId}&page=${page}&items=${itemsPerPage}&from=${from}&to=${to}&search=${search}&status=${status}`;
    return this.axios.get(url, {
      method: "get",
      signal
    });
  }









  public async getOneAppointment(id: any): Promise<GetOneAppointmentResponseService> {
    let url = `/appointments/${id}`
    return this.axios.get(url);
  }



  // GET ALL EXISTING APPOINTMENTS
  public async getAllAppointments(
    items: number,
    page: number,
    signal?: AbortSignal
  ): Promise<GetAllAppointmentsResponseService> {
    let chosenCompany: string;
    if (this.getStore.getState().user.currentCompany) {
      chosenCompany = this.getStore.getState().user.currentCompany.id;
    }
    else {
      chosenCompany = this.getStore.getState().user.companies[0].id
    }
    const url: string = `/appointments?companyId=${chosenCompany}&items=${items}&page=${page}`;
    return this.axios.get(url, {
      method: "get",
      signal
    });
  }

  public async getDashboardAppointmens(
    signal?: AbortSignal
  ): Promise<GetAllAppointmentsResponseService> {
    const url: string = `/appointments-pc/dashboard`;
    return this.axios.get(url, {
      method: "get",
      signal
    });
  }


  public async findActiveAppsByUserId(userId: string): Promise<boolean> {
    const url: string = `/appointments/activeApps/${userId}`;
    return this.axios.get(url);
  }

  //GET ALL APPOINTMENTS FOR AN INDIVIDUAL EMPLOYEE
  public async getIndividualsAppointments(
    patientID: string,
    items: number,
    page: number,
  ): Promise<IndividualAppointmentResponseService> {
    const url: string = `/appointments/patients/${patientID}?items=${items}&page=${page}`;
    return this.axios.get(url, {
      method: "get",
    });
  }

  // GET ALL EMPLOYEES THAT HAVE APPOINTMENTS
  public async getAppointmentEmployees(
    items: number,
    page: number,
    signal?: AbortSignal
  ): Promise<GetAllAppointmentEmployee> {
    let chosenCompany: string;
    if (this.getStore.getState().user.currentCompany) {
      chosenCompany = this.getStore.getState().user.currentCompany.id;
    }
    else {
      chosenCompany = this.getStore.getState().user.companies[0].id
    }
    const url: string = `/appointments/employees?companyId=${chosenCompany}&items=${items}&page=${page}`;
    return this.axios.get(url, {
      method: "get",
      signal
    });
  }

  // GET ALL CANDIDATES THAT HAVE APPOINTMENTS
  public async getAppointmentCandidates(
    items: number,
    page: number,
    signal?: AbortSignal
  ): Promise<GetAllAppointmentCandidates> {
    let chosenCompany: string;
    if (this.getStore.getState().user.currentCompany) {
      chosenCompany = this.getStore.getState().user.currentCompany.id;
    }
    else {
      chosenCompany = this.getStore.getState().user.companies[0].id
    }
    const url: string = `/appointments/candidates?companyId=${chosenCompany}&items=${items}&page=${page}`;
    return this.axios.get(url, {
      method: "get",
      signal
    });
  }
  // GET ALL PARTICULAR PATIENTS THAT HAVE APPOINTMENTS
  public async getAppointmentPatient(
    patientId?: string,
  ): Promise<GetAllAppointmentPatient> {
    //let chosenCompany: string = this.getStore.getState().user.currentCompany.id;
    const url: string = `/appointments/patients/${patientId}`;
    return this.axios.get(url, {
      method: "get",
    });
  }
  // GET ALL PARTICULAR PATIENTS THAT HAVE APPOINTMENTS
  public async getParticularClientsApp(
    page: number,
    itemsPerPage: number,
    from: string,
    to: string,
    signal: AbortSignal,
  ): Promise<IndividualAppointment[]> {
    const url = `appointments-particular/querySearch?page=${page}&items=${itemsPerPage}&from=${from}&to=${to}`
    //const url: string = `/appointments/patients/${patientId}/unfinished`;
    return this.axios.get(url, {
      method: "get",
      signal,
    });
  }
  // GET ALL PRACTICES ATTACHED TO A SPECIFIC APPOINTMENT
  public async getAppointmentPractices(appointmentId?: string) {
    const url: string = `/appointments/${appointmentId}`;
    // TODO: CREATE RETURN TYPE FOR THIS REQUEST
    const response: any = await this.axios.get(url, {
      method: "get",
    });
    let slots = response.slots || [];
    let practiceArray = [];
    for (let i = 0; i < slots.length; i++) {
      const { alias, ...rest } = slots[i].practice;
      practiceArray.push(alias);
    }
    let practices = practiceArray.toString() || "";
    return practices;
  }

  // EDIT APPOINTMENT
  public async getAppointmentEditTurnSlots(
    appointmentId?: string,
    practices?: string,
  ): Promise<GetAppointmentEditResponseService> {
    const url: string = `/appointments/options/${appointmentId}?practices=${practices}`;
    return this.axios.get(url, {
      method: "get",
    });
  }

  // WATCH PARTICULAR CLIENTS APPOINTMENT RESULTS
  public async getAppointmentResultsOfParticularClients(
    page: number,
    itemsPerPage: number,
    signal: AbortSignal,
  ): Promise<IndividualAppointment[]> {
    const url: string = `/appointments-particular/reports?items=${page}&itemsPerPage=${itemsPerPage}`;
    return this.axios.get(url, {
      method: "get",
      signal,
    });
  }
  //MENSAGES DE GESTION
  public async getAppointmentsFollowUp(appointment_id: string,): Promise<any[]> {
    const url = `appointment-follow-ups?appointment_id=${appointment_id}`
    return this.axios.get(url)
  }


  //CONTROL CONSULTORIO PDFS

  public async getAppPdfFile(appId: string): Promise<string> {
    const url = `appointments-specialist/app_pdf_file/${appId}`;
    return this.axios.get(url);
  }
  //REPORTS
  public async getReportes(from: string, to: string, company_id: string): Promise<any[]> {
    const url = `appointments-pc/reports?from=${from}&to=${to}&company_id=${company_id}`
    return this.axios.get(url);
  }

}
